import {
  $changePermissions,
  $createFolder,
  $deleteFolders,
  $getFolder,
  $getFolderInfo,
  $updateFolder,
  changePermissions,
  createFolder,
  deleteFolders,
  getFolder,
  getFolderInfo,
  updateFolder,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    createFolder,
    changePermissions,
    updateFolder,
    deleteFolders,
    getFolderInfo,
    getFolder,
  },
};

export const $actions = {
  createFolder: $createFolder,
  changePermissions: $changePermissions,
  updateFolder: $updateFolder,
  deleteFolders: $deleteFolders,
  getFolderInfo: $getFolderInfo,
  getFolder: $getFolder,
};
